export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-7fd2dfb360173931e57f70f82d7e3784.svg";